module.exports = __webpack_public_path__ + "img/orders-table-file.ed8c93f3.svg";